import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import { connect } from "react-redux";
import {
  StyledModal,
  StyledTitle,
  StyledBody,
  DetailInitiativeWrapper,
  CircleNew,
} from "./styles";
import { RecognitionCloseIcon } from "../../../utils/icons";
import CircularProgressBar from "../../HealthTabV2/HealthTabUpdated/circularProgressBar";
import { GetCoreValueDetailsById } from "../../../redux/constants/apiConstants";
import { fetchApi } from "../../../utils/methods";
import { toast } from "react-toastify";
import SkeletonLoder from "../../common/skeletonLoder";

class CoreValuePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initiative: null,
      printCSV: false,
      isloading: false,
      initiativeReportData: [],
      initPercentage: 60,
      getValueById: [],
      loading:false,
    };
  }

  componentDidMount() {
    if (this.props.detailInitiative) {
      this.setState({ initiative: this.props.detailInitiative });
    }
    this.getCoreValueById(this.props.companyId, this.props.detailInitiative?.id)
  }

  getCoreValueById = async (companyId, CoreValueId) => {
    this.setState({ loading: true })
    try {
      const res = await fetchApi(GetCoreValueDetailsById + "/" + companyId + "/" + CoreValueId, "GET");
      if (res.data.message) {
        toast.error(res?.data?.message);
      } else {
        this.setState({ getValueById: res?.data })
        this.setState({ loading: false })
      }
    } catch (error) {
      // toast.error(error)
    }
  }

  // Use componentDidUpdate to update the initiative if the prop changes
  componentDidUpdate(prevProps) {
    if (prevProps.detailInitiative !== this.props.detailInitiative) {
      this.setState({ initiative: this.props.detailInitiative });
    }
  }

  showDetailInitiative = () => {
    const { initiative, getValueById } = this.state;


    if (!getValueById) return null;
    return (
      <React.Fragment>
        <div className="row-one">
          <div className="col-one">
            {initiative?.white_icon && <LazyImage
              div={'image'}
              background={getValueById?.color}
              style={{ width: "24px", height: "24px" }}
              src={ImageUrl + "/" + initiative?.white_icon}
            />}
            <div className="details">
              <div>
                <span className="name">{getValueById?.core_value}</span>
              </div>
              <div style={{ marginTop: "10px" }}>
                <span className="points">
                  {getValueById?.active_status}
                </span>
                <span className="points"> |  +{getValueById?.point} {getValueById?.point > 0 ? "pts" : "pt"}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row-two">
          <div style={{ marginRight: "20px" }}>
            <span
              className="user-count"
            >
              {getValueById?.total_recognition_received > 1 ? `${getValueById?.total_recognition_received} users` : `${getValueById?.total_recognition_received} user`} Received
            </span>{" "}
          </div>
          <div>
            <div className="circularPercentage">
              <CircleNew width="170px" height="170px">
                <CircularProgressBar
                  strokeWidth="40"
                  sqSize="160"
                  percentage={getValueById?.percentage}
                  color={getValueById?.percentage_color_code}
                  hideText={true}
                  strokeShape={"butt"}
                />
              </CircleNew>
            </div>
          </div>
        </div>

      </React.Fragment>
    );
  };

  

  render() {
    const { showModal, onClose /*detailInitiative*/ } = this.props;
    const { getValueById,loading } = this.state


    if (loading){
      <SkeletonLoder width={"400px"} height={"auto"} style={{marginTop:"20px"}}/>
    }
    else{
      return (
        <StyledModal
          transform={1}
          show={showModal}
          newWidth={"400px"}
          newBg={"newBg"}
          // height="50px"
          display="none"
        >
          <Modal.Header
            closeButton
            onHide={() => onClose()}
            style={{ background: "white" }}
          >
            <StyledTitle>Core Value Info </StyledTitle>
            <div
              onClick={() => onClose()}
              style={{ cursor: "pointer" }}
            >
              {RecognitionCloseIcon()}
            </div>
          </Modal.Header>
          <StyledBody>
            <DetailInitiativeWrapper background={getValueById?.recognition_color_value}>
              {getValueById && this.showDetailInitiative()}
            </DetailInitiativeWrapper>
          </StyledBody>
        </StyledModal>
      );}
  }
}

CoreValuePopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  detailInitiative: PropTypes.object,
  companyId: PropTypes.number,
};

const mapStateToProps = (state) => ({
  userId: state.profileData.userId,
});

export default connect(mapStateToProps, null)(CoreValuePopup);
